import { types as t } from 'mobx-state-tree';
import { AbstractQuestionWithBlankCorrectAnswers } from '../abstract-question-with-blank-correct-answers.store';
import { AbstractQuestionWithBlanks } from '../abstract-question-with-blanks.store';

const Sentence = AbstractQuestionWithBlanks.named('Sentence');

export const SentenceCompleteAnswerQuestions = AbstractQuestionWithBlankCorrectAnswers.named(
  'SentenceCompleteAnswerQuestions'
).props({
  sentences: t.array(Sentence),
});
